import { gql } from '@apollo/client';

const GET_ORG = gql`
  query getOrg(
    $id: ID!
    $take: Int!
    $skip: Int!
    $query: QuerySites
    $order: [[String]]
  ) {
    getOrg(id: $id) {
      sitesPaged(
        pagination: { take: $take, skip: $skip }
        query: $query
        order: $order
      ) {
        data {
          id
          name
        }
        pagination {
          skip
          take
          total
        }
      }
    }
  }
`;
export { GET_ORG };
